import Fetch from '@/utils/Fetch';

const getImports = async (pageSize: any, pageIndex: any, sortExpression: any, sortDirection: any, searchPhrase: any, importTypeList: any, importStatusList: any) => {
    const request = await Fetch.post({
        url: `/Import/GetImports`,
        params: {
          PageSize: pageSize,
          PageIndex: pageIndex,
          SortExpression: sortExpression, 
          SortDirection: sortDirection,
          SearchPhrase: searchPhrase,
          ImportTypeList: importTypeList,
          ImportStatusList: importStatusList,
        }
      });
    return {data: request.Results, total: request.TotalResults};
};

export default {
    getImports,
};
